// ── VIP kaparós popup: hol és mikor jelenhet meg (audit 2026-10-26, #3) ──────
//
// A popup a VIP-szabályokon (CLAUDE.md: bezárható, nincs sürgetés, telefonszámot
// nem kér) NEM változtat – csak azon, hogy MIKOR és HOL ugorhat fel:
//   1. csak a süti-döntés UTÁN (különben a cookie-sávot takarná),
//   2. csak szándékjel után: 30 s az oldalon, VAGY ≥50%-os görgetés, VAGY
//      asztali gépen kilépési szándék (az egér kimegy az ablak tetején),
//   3. döntési/jogi/terméklapokon SOHA (ott a látogató épp mást csinál),
//   4. bezárás után 7 napig nem.

export const POPUP_KESLELTETES_MS = 30000;
export const POPUP_GORGETES_ARANY = 0.5;
export const POPUP_SZUNET_NAP = 7;
export const POPUP_KULCS = 'norbiphone_popup_v1';

// Pontos útvonalak (záró perjel nélkül összevetve).
const MENTES_PONTOS = new Set([
  // felvásárlás (a kalkulátor maga a konverzió – ott nem zavarunk)
  '/felvasarlas', '/telefon-felvasarlas-oroshaza', '/hasznalt-telefon-eladas-oroshaza',
  '/telefon-becsere-oroshaza', '/telefon-eladas-azonnal-oroshaza', '/iphone-eladas-oroshaza',
  '/samsung-eladas-oroshaza', '/hasznalt-telefon-felvasarlas-oroshaza', '/ipad-eladas-oroshaza',
  '/apple-watch-eladas-oroshaza', '/iphone-felvasarlas-oroshaza', '/samsung-felvasarlas-oroshaza',
  // jogi oldalak
  '/aszf', '/adatkezeles', '/impresszum', '/cookie', '/bejelentes-adatkezeles', '/akadalymentesseg',
  // ahol a kaparós már az oldal tartalma, vagy a szabályait olvassa
  '/vip-klub', '/vip-jatekszabalyzat',
  // mérő- és SMS-landingek (CTA-mentes oldalak)
  '/eszkozteszt', '/nyitva', '/hivtal',
]);
// Előtagok: minden ALATTUK lévő oldal (pl. /telefonok/1105 – a terméklap),
// maga a /telefonok lista viszont nem. Az /admin maga is tiltott.
const MENTES_ALOLDALAK = ['/telefonok', '/admin'];

const norm = (p = '') => (p.length > 1 ? p.replace(/\/+$/, '') : p);

/** Ezen az útvonalon tilos-e a popup? A /telefonok LISTA nem tiltott, csak a terméklap. */
export const popupMentesUtvonal = (pathname = '') => {
  const p = norm(pathname);
  if (MENTES_PONTOS.has(p)) return true;
  if (p === '/admin') return true;
  // Bolt mód (/bolt/…, szerviz-mentes hirdetési oldalak – utils/boltMod.js): a
  // VIP-kaparós SEHOL nem jelenhet meg. A nyereménylistában szerviz-utalás van
  // („szervizkupon”), és a hirdetési landingen nem lehet felugró ablak.
  if (p === '/bolt' || p.startsWith('/bolt/')) return true;
  return MENTES_ALOLDALAK.some((e) => p.startsWith(`${e}/`));
};

/** Szünetel-e még (7 napon belül bezárták)? Sérült tárolt érték → nem szünetel. */
export const popupSzunetel = (tarolt, most = Date.now()) => {
  if (!tarolt) return false;
  try {
    const { dismissedAt } = JSON.parse(tarolt);
    if (typeof dismissedAt !== 'number') return false;
    return (most - dismissedAt) / 86400000 < POPUP_SZUNET_NAP;
  } catch {
    return false;
  }
};
